var map = {
	"./cards/1.png": "6cf8",
	"./cards/11.png": "be66",
	"./cards/13.png": "4f3b",
	"./cards/15.png": "2e6f",
	"./cards/17.png": "bc21",
	"./cards/19.png": "f648",
	"./cards/3.png": "535d",
	"./cards/5.png": "8b2d",
	"./cards/7.png": "2fd5",
	"./cards/9.png": "7088",
	"./cards/newCards/1.png": "0800",
	"./cards/newCards/11.png": "f0696",
	"./cards/newCards/3.png": "4ec1",
	"./cards/newCards/5.png": "1f32",
	"./cards/newCards/7.png": "eee6",
	"./cards/newCards/9.png": "9794",
	"./checklist_1.png": "77cc",
	"./checklist_1_french.png": "c6a4",
	"./checklist_1_ger.png": "85ee",
	"./checklist_2.png": "2663",
	"./checklist_2_french.png": "1513",
	"./checklist_2_ger.png": "4307",
	"./checklist_3.png": "5317",
	"./checklist_3_french.png": "1a21",
	"./checklist_3_ger.png": "0439",
	"./checklist_4.png": "b154",
	"./checklist_4_french.png": "5e9a",
	"./checklist_4_ger.png": "d08b",
	"./checklist_5.png": "2a7f",
	"./checklist_5_french.png": "8eeb",
	"./checklist_5_ger.png": "9b09",
	"./checklist_6.png": "0644",
	"./checklist_6_french.png": "52ac",
	"./checklist_6_ger.png": "0ab2",
	"./checklist_desk.png": "6b23",
	"./checklist_desk_french.png": "bfb2",
	"./checklist_desk_ger.png": "d933",
	"./checklist_ger.png": "e11e",
	"./checklist_v2_ger@2x.png": "a7f1",
	"./chromebook.png": "2a92",
	"./chromebook_logo.png": "3fde",
	"./chromebook_logo_crop.png": "6e1c",
	"./chromes_lobby.png": "bccb",
	"./chromes_splash.png": "ff27",
	"./clue_chromebook.png": "f899",
	"./clue_chromebook_drive.png": "e884",
	"./clue_chromebook_login.png": "1350",
	"./clue_chromebook_login2.png": "3303",
	"./clue_completed_note.png": "6ac7",
	"./clue_lock.png": "57d2",
	"./clue_records.png": "0302",
	"./clue_ripped_note.png": "3b8b",
	"./clue_router.png": "5a09",
	"./clue_scorecard.png": "58f8",
	"./clue_signature.png": "f02e",
	"./clue_sunset.png": "64cd",
	"./docDetective/228_btn1.png": "2c33",
	"./docDetective/228_btn2.png": "651e",
	"./docDetective/242_btn1.png": "b793",
	"./docDetective/242_btn2.png": "c1e3",
	"./docDetective/352_btn1.png": "bd96",
	"./docDetective/352_btn2.png": "2171",
	"./docDetective/empty_folder.png": "b053",
	"./docDetective/fr_228_btn1.png": "ad65",
	"./docDetective/fr_228_btn2.png": "4093",
	"./docDetective/fr_242_btn1.png": "2224",
	"./docDetective/fr_242_btn2.png": "bbd5",
	"./docDetective/fr_352_btn.png": "a81f",
	"./docDetective/fr_352_btn2.png": "2cf1",
	"./docDetective/fr_empty_folder.png": "5fd8",
	"./docDetective/fr_last_edit_btn1.png": "fbb0",
	"./docDetective/fr_last_edit_btn2.png": "336b",
	"./docDetective/fr_restore_btn.png": "1735",
	"./docDetective/fr_tabs.png": "513b",
	"./docDetective/fr_true_gem_edited.png": "fd99",
	"./docDetective/fr_true_gem_page.png": "3418",
	"./docDetective/fr_version_history.png": "bc9e",
	"./docDetective/ger_228_btn1.png": "f4fc",
	"./docDetective/ger_228_btn2.png": "2fa7",
	"./docDetective/ger_242_btn1.png": "e75a",
	"./docDetective/ger_242_btn2.png": "003a",
	"./docDetective/ger_352_btn1.png": "b93f",
	"./docDetective/ger_352_btn2.png": "744f",
	"./docDetective/ger_empty_folder.png": "14bd",
	"./docDetective/ger_last_edit_btn1.png": "fbc7",
	"./docDetective/ger_last_edit_btn2.png": "1542",
	"./docDetective/ger_restore_btn.png": "f497",
	"./docDetective/ger_tabs.png": "085d",
	"./docDetective/ger_title.png": "e040",
	"./docDetective/ger_true_gem.png": "788e",
	"./docDetective/ger_true_gem_edited.png": "811c",
	"./docDetective/ger_true_gem_edited_v2.png": "8bcb",
	"./docDetective/ger_true_gem_page.png": "4405",
	"./docDetective/ger_version_history.png": "c326",
	"./docDetective/icons.png": "b297",
	"./docDetective/last_edit_btn1.png": "8600",
	"./docDetective/last_edit_btn2.png": "6531",
	"./docDetective/restore_btn.png": "7f21",
	"./docDetective/tabs.png": "8bcc",
	"./docDetective/true_gem_edited.png": "937c",
	"./docDetective/true_gem_page.png": "efe3",
	"./docDetective/version_history.png": "fe3b",
	"./docs.png": "eab0",
	"./drivelogo.png": "c804",
	"./drivelogo_transparent.png": "0a09",
	"./forms.png": "ac2e",
	"./icons/YouTube_TV_logo.png": "8e4f",
	"./icons/answer_right.png": "4e3c",
	"./icons/answer_wrong.png": "c01e",
	"./icons/cal_btn.png": "fe5e",
	"./icons/chrome_btn.png": "f386",
	"./icons/chromebook_banner.png": "2ec8",
	"./icons/doc_icon.png": "6100",
	"./icons/docsSheetsSlides.png": "9f29",
	"./icons/docs_btn.png": "edaa",
	"./icons/drive_btn.png": "c744",
	"./icons/folder_icon.png": "a8f8",
	"./icons/google_calendar.png": "bb81",
	"./icons/green_button.png": "42cc",
	"./icons/header_img.png": "fc32",
	"./icons/logo_chrome.png": "65f7",
	"./icons/logo_docs.png": "f52c",
	"./icons/logo_drive.png": "7f68",
	"./icons/logo_ghome.png": "0d22",
	"./icons/logo_gmail.png": "4c7a",
	"./icons/logo_gmaps.png": "21a3",
	"./icons/logo_hangouts.png": "298a",
	"./icons/logo_hangoutsmeet.png": "1239",
	"./icons/logo_keep.png": "f605",
	"./icons/logo_photos.png": "d64c",
	"./icons/logo_play_store.png": "84d6",
	"./icons/logo_play_store_v2.png": "b6ac",
	"./icons/logo_sheets.png": "f120",
	"./icons/logo_slides.png": "9113",
	"./icons/logo_translate.png": "0192",
	"./icons/logo_youtube.png": "88ce",
	"./icons/maps_btn.png": "af04",
	"./icons/play_btn.png": "0362",
	"./icons/purple_btn.png": "e924",
	"./icons/sheets_btn.png": "320f",
	"./icons/status/answer_right.png": "17c7",
	"./icons/status/answer_wrong.png": "a555",
	"./icons/translate_btn.png": "8711",
	"./icons/youtube_btn.png": "24d4",
	"./logo.png": "9d64",
	"./logo_chrome.png": "82f2",
	"./puzzles/docsIdentify.png": "8a00",
	"./puzzles/formsIdentify.png": "2dd5",
	"./puzzles/postIt.png": "ba32",
	"./puzzles/postit_426x426.png": "7d1f",
	"./puzzles/postit_complete_426x426.png": "f04e",
	"./puzzles/sheetsIdentify.png": "7fee",
	"./puzzles/slidesIdentify.png": "dc58",
	"./simonApps/icon_docs.png": "5bfc",
	"./simonApps/icon_forms.png": "a70a",
	"./simonApps/icon_music.png": "9be8",
	"./simonApps/icon_photo.png": "40d6",
	"./simonApps/icon_sheets.png": "5f89",
	"./simonApps/icon_slides.png": "3b85",
	"./simonApps/icon_video.png": "b72c",
	"./simonAppsLabeled/docs.png": "211c",
	"./simonAppsLabeled/forms.png": "28b3",
	"./simonAppsLabeled/ger_photos.png": "8495",
	"./simonAppsLabeled/ger_sheets.png": "8f59",
	"./simonAppsLabeled/ger_slides.png": "67ba",
	"./simonAppsLabeled/google_photos.png": "fb77",
	"./simonAppsLabeled/music.png": "2854",
	"./simonAppsLabeled/photo.png": "f9f1",
	"./simonAppsLabeled/sheets.png": "a29e",
	"./simonAppsLabeled/slides.png": "8f07",
	"./simonAppsLabeled/video.png": "e631",
	"./storyImages/Assets-01.png": "f01b",
	"./storyImages/Assets-02.png": "0e73"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";